<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold">Adjust payout</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form">
    <div class="col-4">
      <label for="payout" class="form-label fw-bold small">Payout</label>
      <div class="input-group">
        <span class="input-group-text"><i class="bi bi-cash"></i></span>
        <input type="text" class="form-control" id="payout" formControlName="payout">
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
  <button form="form" type="submit" class="btn btn-primary fw-bold">Update</button>
</div>
